/* eslint-disable no-underscore-dangle */
/* global navigator */

define([
  'react',
  'underscore',
], (React, _) => {
  const { attachEvent } = document;
  const isIE = navigator.userAgent.match(/Trident/);
  const requestFrame = (() => {
    const raf = (
      window.requestAnimationFrame
      || window.mozRequestAnimationFrame
      || window.webkitRequestAnimationFrame
      || (fn => window.setTimeout(fn, 20))
    );

    return fn => raf(fn);
  })();

  const cancelFrame = (() => {
    const cancel = (
      window.cancelAnimationFrame
      || window.mozCancelAnimationFrame
      || window.webkitCancelAnimationFrame
      || window.clearTimeout
    );

    return id => cancel(id);
  })();

  const Resize = ComposedComponent => (
    class extends React.PureComponent {
      componentDidMount() {
        if (this.el) {
          this.resizeEl = this.el.getResizeNode();
          this.onResize = _.throttle(this.el.onResize.bind(this.el), 10);
        }

        this.addResizeListener(this.resizeEl, this.onResize);
      }

      componentWillUnmount() {
        this.removeResizeListener(this.resizeEl, this.onResize);
      }

      componentRef = (el) => {
        this.el = el;
      }

      addResizeListener = (el, fn) => {
        const element = el;
        if (!element) return;

        if (!this.resizeListeners) {
          this.resizeListeners = [];
          if (attachEvent) {
            this.resizeListeners = element;
            attachEvent('onresize', this.resizeListener);
          } else {
            if (window.getComputedStyle(element).position === 'static') {
              element.style.position = 'relative';
            }

            const obj = document.createElement('object');
            this.resizeTrigger = obj;

            obj.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1;');
            obj.resizeElement = element;
            obj.onload = this.objectLoad;
            obj.type = 'text/html';
            if (isIE) document.body.appendChild(obj);
            obj.data = 'about:blank';
            if (!isIE) element.appendChild(obj);
          }
        }

        this.resizeListeners.push(fn);
      };

      objectLoad = (e) => {
        const win = e.target || e.srcElement;
        win.contentDocument.defaultView.resizeTrigger = this.resizeElement;
        win.contentDocument.defaultView.addEventListener('resize', this.resizeListener);

        function handleResize(fn) {
          fn.call(this, e);
        }

        // fire resize handler initially on load so stuff sets up properly first time
        (this.resizeListeners || []).forEach(handleResize);
      }

      resizeListener = (e) => {
        const win = e.target || e.srcElement;
        if (win.__resizeRAF__) cancelFrame(win.__resizeRAF__);
        win.__resizeRAF__ = requestFrame(() => {
          function handleResize(fn) {
            fn.call(this, e);
          }

          (this.resizeListeners || []).forEach(handleResize);
        });
      }

      removeResizeListener(element, fn) {
        if (!this.resizeListeners || !this.resizeListeners.length) return;

        this.resizeListeners.splice(this.resizeListeners.indexOf(fn), 1);
        if (!this.resizeListeners.length) {
          if (attachEvent) {
            element.detachEvent('onresize', this.resizeListeners);
          } else if (this.resizeTrigger && this.resizeTrigger.contentDocument) {
            this.resizeTrigger.contentDocument.defaultView.removeEventListener('resize', this.resizeListener);
            this.resizeTrigger = !element.removeChild(this.resizeTrigger);
          }
        }
      }

      render() {
        return <ComposedComponent ref={this.componentRef} {...this.props} />;
      }
    }
  );

  return Resize;
});
